import {CONSTANTS as Classificators} from "../classificators/classificator-value.constants";
import {IdCodeNameQuery} from "../../models/base.query";

export class PropertyQuery extends IdCodeNameQuery {
  Sequence: number;
  GroupClv: string;
  TypeClv: string;
  UnitId: string;
  RoundingFactor?: number;
  ChoiceTypeClassificatorId: string;
  IsMultiValue: boolean;

  static Columns() {
    return [...IdCodeNameQuery.Columns(), 'Sequence', 'GroupClv', 'TypeClv', 'UnitId', 'RoundingFactor', 'ChoiceTypeClassificatorId', 'IsMultiValue'];
  }

  get DigitsInfo(): string {
    const roundTo = this.RoundingFactor === null ? 0: this.RoundingFactor;
    return `1.${roundTo}-${roundTo}`;
  }

  isNumeric() {
    return this.TypeClv === Classificators.PropertyType.Numeric;
  }

  isText() {
    return this.TypeClv === Classificators.PropertyType.Text;
  }

  isChoice() {
    return this.TypeClv === Classificators.PropertyType.Choice;
  }

  isHtml() {
    return this.TypeClv === Classificators.PropertyType.Html;
  }

  isDateTime() {
    return this.TypeClv === Classificators.PropertyType.DateTime;
  }

  isJson() {
    return this.TypeClv === Classificators.PropertyType.Json;
  }
}

